<template>
  <div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box">
      <el-form
        ref="form"
        label-width="auto"
        label-position="right"
        label-suffix="："
        :model="dioForm"
        :rules="rules"
        v-loading="loading"
      >
    <!-- 区分十种情况 useFuncType-->
    <!-- 上报规则 -->
    <!-- zigbee -->
    <template v-if="useFuncType === 1 || useFuncType === 2">
      <!-- zigbee湿度 -->
      <el-form-item
        :label="$t('device.sample_interval')"
        prop="collectInterval"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.collectInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['collectIntervalCurrent']">
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['collectIntervalCurrent'] &&
                dioForm['collectIntervalCurrent'].change
            "
            >{{ dioForm['collectIntervalCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['collectIntervalCurrent']" style="color:red">{{
            dioForm['collectIntervalCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item
        :label="$t('device.exception_sample_interval')"
        prop="exCollectInterval"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.exCollectInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['exCollectIntervalCurrent']">
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['exCollectIntervalCurrent'] &&
                dioForm['exCollectIntervalCurrent'].change
            "
            >{{ dioForm['exCollectIntervalCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['exCollectIntervalCurrent']" style="color:red">{{
            dioForm['exCollectIntervalCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
    </template>
    <!-- lora 3，4  -->
    <!-- zeta 5，6 -->
    <template v-else-if="useFuncType >= 3 && useFuncType <= 6">
      <el-form-item
        :label="$t('device.temp_sample_interval')"
        prop="tempCollectInterval"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.tempCollectInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['tempCollectIntervalCurrent'] &&
                dioForm['tempCollectIntervalCurrent'].change
            "
            >{{ dioForm['tempCollectIntervalCurrent'].current + '-->' }}</span
          >
          <span
            v-if="dioForm['tempCollectIntervalCurrent']"
            style="color:red"
            >{{ dioForm['tempCollectIntervalCurrent'].modify }}</span
          >
        </template>
      </el-form-item>
      <el-form-item
        :label="$t('device.temp_change_threshold')"
        prop="tempChange"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.tempChange"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['tempChangeCurrent'] &&
                dioForm['tempChangeCurrent'].change
            "
            >{{ dioForm['tempChangeCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['tempChangeCurrent']" style="color:red">{{
            dioForm['tempChangeCurrent'].modify
          }}</span>
        </template>
      </el-form-item>
      <el-form-item
        :label="$t('device.max_temp_report_interval')"
        prop="tempMaxReport"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.tempMaxReport"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['tempMaxReportCurrent'] &&
                dioForm['tempMaxReportCurrent'].change
            "
            >{{ dioForm['tempMaxReportCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['tempMaxReportCurrent']" style="color:red">{{
            dioForm['tempMaxReportCurrent'].modify
          }}</span>
        </template>
      </el-form-item>
      <el-form-item
        :label="$t('device.min_temp_report_interval')"
        prop="tempMinReport"
      >
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.tempMinReport"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <span
            v-if="
              configStatus !== 2 &&
                dioForm['tempMinReportCurrent'] &&
                dioForm['tempMinReportCurrent'].change
            "
            >{{ dioForm['tempMinReportCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['tempMinReportCurrent']" style="color:red">{{
            dioForm['tempMinReportCurrent'].modify
          }}</span>
        </template>
      </el-form-item>
      <!-- lora湿度 -->
      <template v-if="useFuncType === 4 || useFuncType === 6">
        <el-form-item
          :label="$t('device.hum_sample_interval')"
          prop="humCollectInterval"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.humCollectInterval"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['humCollectIntervalCurrent'] &&
                  dioForm['humCollectIntervalCurrent'].change
              "
              >{{ dioForm['humCollectIntervalCurrent'].current + '-->' }}</span
            >
            <span
              v-if="dioForm['humCollectIntervalCurrent']"
              style="color:red"
              >{{ dioForm['humCollectIntervalCurrent'].modify }}</span
            >
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('device.hum_change_threshold')"
          prop="humChange"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.humChange"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['humChangeCurrent'] &&
                  dioForm['humChangeCurrent'].change
              "
              >{{ dioForm['humChangeCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['humChangeCurrent']" style="color:red">{{
              dioForm['humChangeCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('device.max_hum_report_interval')"
          prop="humMaxReport"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.humMaxReport"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['humMaxReportCurrent'] &&
                  dioForm['humMaxReportCurrent'].change
              "
              >{{ dioForm['humMaxReportCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['humMaxReportCurrent']" style="color:red">{{
              dioForm['humMaxReportCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('device.min_hum_report_interval')"
          prop="humMinReport"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.humMinReport"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['humMinReportCurrent'] &&
                  dioForm['humMinReportCurrent'].change
              "
              >{{ dioForm['humMinReportCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['humMinReportCurrent']" style="color:red">{{
              dioForm['humMinReportCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
      </template>
    </template>
    <!--二代温度计 7 8-->
    <template v-else-if="useFuncType >= 7 && useFuncType <= 8">
      <GenTwoTempConfig
        ref="genTwoConfig"
        :row-data="rowData"
        :is-click-config="isClickConfig"
      >
      </GenTwoTempConfig>
    </template>

    <!--4G温度计-->
    <template v-else-if="useFuncType >= 9 && useFuncType <= 12">
      <FourGTempConfig
        ref="fourGConfig"
        :row-data="rowData"
        :is-click-config="isClickConfig"
      ></FourGTempConfig>
    </template>
      </el-form>
      <div class="form-actions" v-if="configStatus !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sensorUpdateAppConfig } from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import FourGTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/FourGTempConfig/FourGTempConfig.vue'
import GenTwoTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/GenTwoTempConfig/GenTwoTempConfig.vue'

export default {
  components: {
    GenTwoTempConfig,
    FourGTempConfig
  },
  props: ['useFuncType', 'rowData', 'sensorConfig'],
  computed: {
    configStatus () {
      if (this.sensorConfig) {
        return this.sensorConfig.status
      } else {
        return 2
      }
    },
    // 正则不会写啊  难搞
    rules () {
      const rules = addRules.call(this, 'rule', [
        'collectInterval',
        'exCollectInterval',
        'tempCollectInterval',
        'tempChange',
        'tempMaxReport',
        'tempMinReport',
        'humCollectInterval',
        'humChange',
        'humMaxReport',
        'humMinReport'
      ])
      return rules
    }
  },
  watch: {
    sensorConfig: {
      handler () {
        if (this.sensorConfig) {
          if (this.sensorConfig.content) {
            const JsonContent = JSON.parse(this.sensorConfig.content)

            this.cmd = JsonContent.cmd
            if (this.useFuncType === 1 || this.useFuncType === 2) {
              this.dioForm = {
                collectInterval: JsonContent.item.collect_interval.modify,
                collectIntervalCurrent: JsonContent.item.collect_interval,
                exCollectInterval: JsonContent.item.ex_collect_interval.modify,
                exCollectIntervalCurrent: JsonContent.item.ex_collect_interval
              }
            } else if (this.useFuncType === 3 || this.useFuncType === 4) {
              this.dioForm = {
                tempCollectInterval:
                  JsonContent.item.temp_collect_interval.modify,
                tempCollectIntervalCurrent:
                  JsonContent.item.temp_collect_interval,

                tempChange: JsonContent.item.temp_change.modify,
                tempChangeCurrent: JsonContent.item.temp_change,

                tempMaxReport: JsonContent.item.temp_max_report.modify,
                tempMaxReportCurrent: JsonContent.item.temp_max_report,

                tempMinReport: JsonContent.item.temp_min_report.modify,
                tempMinReportCurrent: JsonContent.item.temp_min_report
              }
              if (this.useFuncType === 4) {
                this.dioForm = Object.assign({}, this.dioForm, {
                  humCollectInterval:
                    JsonContent.item.hum_collect_interval.modify,
                  humCollectIntervalCurrent:
                    JsonContent.item.hum_collect_interval,

                  humChange: JsonContent.item.hum_change.modify,
                  humChangeCurrent: JsonContent.item.hum_change,

                  humMaxReport: JsonContent.item.hum_max_report.modify,
                  humMaxReportCurrent: JsonContent.item.hum_max_report,

                  humMinReport: JsonContent.item.hum_min_report.modify,
                  humMinReportCurrent: JsonContent.item.hum_min_report
                })
              }
            } else if (this.useFuncType === 5 || this.useFuncType === 6) {
              this.dioForm = {
                tempCollectInterval:
                  JsonContent.item.temp_collect_interval.modify,
                tempCollectIntervalCurrent:
                  JsonContent.item.temp_collect_interval,

                tempChange: JsonContent.item.temp_change.modify,
                tempChangeCurrent: JsonContent.item.temp_change,

                tempMaxReport: JsonContent.item.temp_max_report.modify,
                tempMaxReportCurrent: JsonContent.item.temp_max_report,

                tempMinReport: JsonContent.item.temp_min_report.modify,
                tempMinReportCurrent: JsonContent.item.temp_min_report
              }
              if (this.useFuncType === 6) {
                this.dioForm = Object.assign({}, this.dioForm, {
                  humCollectInterval:
                    JsonContent.item.hum_collect_interval.modify,
                  humCollectIntervalCurrent:
                    JsonContent.item.hum_collect_interval,

                  humChange: JsonContent.item.hum_change.modify,
                  humChangeCurrent: JsonContent.item.hum_change,

                  humMaxReport: JsonContent.item.hum_max_report.modify,
                  humMaxReportCurrent: JsonContent.item.hum_max_report,

                  humMinReport: JsonContent.item.hum_min_report.modify,
                  humMinReportCurrent: JsonContent.item.hum_min_report
                })
              }
            } else if (this.useFuncType === 7 || this.useFuncType === 8) {
              // 2.4G温度计
              this.$refs.genTwoConfig.setData(JsonContent)
            } else if (this.useFuncType >= 9 || this.useFuncType <= 12) {
              // 4G温度计
              this.$refs.fourGConfig.setData(JsonContent)
            }
          }
          this.$emit('listFn', this.sensorConfig.responseDeviceConfigLogList)
        } else {
          // 默认值
          if (this.useFuncType === 1 || this.useFuncType === 2) {
            this.dioForm = {
              collectInterval: '600',
              collectIntervalCurrent: {
                modify: '600'
              },
              exCollectInterval: '300',
              exCollectIntervalCurrent: {
                modify: '300'
              }
            }
          } else if (this.useFuncType === 3 || this.useFuncType === 4) {
            this.dioForm = {
              tempCollectInterval: '60',
              tempCollectIntervalCurrent: {
                modify: '60'
              },
              tempChange: '1',
              tempChangeCurrent: {
                modify: '1'
              },
              tempMaxReport: '900',
              tempMaxReportCurrent: {
                modify: '900'
              },
              tempMinReport: '60',
              tempMinReportCurrent: {
                modify: '900'
              }
            }
            if (this.useFuncType === 4) {
              this.dioForm = Object.assign({}, this.dioForm, {
                humCollectInterval: '60',
                humCollectIntervalCurrent: {
                  modify: '60'
                },
                humChange: '1',
                humChangeCurrent: {
                  modify: '1'
                },
                humMaxReport: '900',
                humMaxReportCurrent: {
                  modify: '900'
                },
                humMinReport: '60',
                humMinReportCurrent: {
                  modify: '60'
                }
              })
            }
          } else if (this.useFuncType === 5 || this.useFuncType === 6) {
            this.dioForm = {
              tempCollectInterval: '60',
              tempCollectIntervalCurrent: {
                modify: '60'
              },
              tempChange: '1',
              tempChangeCurrent: {
                modify: '1'
              },
              tempMaxReport: '900',
              tempMaxReportCurrent: {
                modify: '900'
              },
              tempMinReport: '60',
              tempMinReportCurrent: {
                modify: '60'
              }
            }
            if (this.useFuncType === 6) {
              this.dioForm = Object.assign({}, this.dioForm, {
                humCollectInterval: '60',
                humCollectIntervalCurrent: {
                  modify: '60'
                },
                humChange: '1',
                humChangeCurrent: {
                  modify: '1'
                },
                humMaxReport: '900',
                humMaxReportCurrent: {
                  modify: '900'
                },
                humMinReport: '60',
                humMinReportCurrent: {
                  modify: '60'
                }
              })
            }
          }
        }
      }
    }
  },
  data () {
    return {
      dioForm: {},
      isClickConfig: true,
      cmd: '',
      listArray: [],
      loading: false,
      appConfig: null
    }
  },

  methods: {
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },

    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async configSave () {
      const flag = await this.justify()
      if (!flag) return

      const query = {
        idList: [this.rowData.id],
        type: this.useFuncType
      }
      switch (this.useFuncType) {
        case 7:
        case 8:
          this.dioForm = await this.$refs.genTwoConfig.getData()
          break
        case 9:
        case 10:
        case 11:
        case 12:
          this.dioForm = await this.$refs.fourGConfig.getData()
          break
      }
      this.loading = true
      for (const key in this.dioForm) {
        if (key.indexOf('Current') === -1) {
          query[key] = this.dioForm[key]
        }
      }
      sensorUpdateAppConfig(query)
        .then(({ result, state }) => {
          if (result && state.code === 200) {
            setTimeout(() => {
              this.$message.success($t('integration.update_successful'))
              this.isClickConfig = !this.isClickConfig
              this.$emit('getList')
            }, 500)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.section-box {
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-left: 3px solid var(--primary-color, #409eff);
  border-radius: 4px;
  padding: 14px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.form-actions {
  text-align: right;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7ed;
}
.cmd-text {
  word-break: break-all;
  font-family: Consolas, Monaco, monospace;
  color: #303133;
}
</style>
